import authActions from '../../web-sh/src/store/actions/auth'

export default {
  ...authActions,
}